<script>
import StringUtils from '@/utils/stringUtils'
import DOMUtils from '@/utils/DOMUtils'

export default
{
    name: 'dropdown-select',

    props:
    {
        label: { type: String, required: true },
        options: { required: true },
        showSelected: { type: Boolean, default: true },
        
        // bound to v-model.
        value: { type: String }
    },

    created ()
    {
    },

    render () 
    {
        const options = Array.isArray(this.options) ? Object.fromEntries(this.options.map(o => [o, o])) : this.options
        const hasError = !StringUtils.isEmptyString(this.errorMessage)
        const hasSelectedValue = !StringUtils.isEmptyString(this.selectedValue) && this.showSelected

        return (
            <div class={`dropdown-select ${ hasError ? 'has-error' : '' }`} on-click={this.dropdownToggle}
                style={{ marginBottom: this.marginBottom }}>
                <div class={`selected ${ hasSelectedValue ? 'has-value' : '' }`}>
                    <div class='label'>{ this.label }</div>
                    <div class='selected-value'>{ options[this.selectedValue] }</div>
                    <inline-svg class={`icon ${ this.dropdownToggled ? 'flipped' : '' }`} src={require('@/assets/img/back.svg')} />
                </div>
                <div class={`options ${ this.showOptions ? 'show' : '' }`} v-show={this.dropdownToggled} ref='options'>
                {
                    Object.entries(options).map(pair =>
                    {
                        return <div class='option' on-click={(e) => this.onOptionClicked(e, pair[0])}>{ pair[1] }</div>
                    })
                }
                </div>
                <div ref='hint' class='hint' v-show={hasError}>
                    {this.errorMessage}
                </div>
            </div>
        )
    },

    mounted ()
    {
        document.addEventListener('click', this.onDocumentClicked, {passive: true, capture: true})
    },

    data () 
    {
        return {
            dropdownToggled: false,
            showOptions: false,
            selectedValue: '',
            errorMessage: '',
            marginBottom: 'unset'
        }
    },

    computed:
    {
    },

    watch:
    {
        errorMessage ()
        {
            setTimeout(() =>
            {
                this.marginBottom = (this.$refs.hint || {}).offsetHeight + 'px'
            }, 10);
        },

        value ()
        {
            this.selectedValue = this.value
        },

        selectedValue ()
        {
            this.$emit('input', this.selectedValue)
        },
    },

    beforeDestroy ()
    {
        this.dropdownToggled = false
        document.removeEventListener('click', this.onDocumentClicked)
    },

    methods:
    {
        dropdownToggle ()
        {
            this.setErrorMessage('')

            this.dropdownToggled = !this.dropdownToggled

            setTimeout(() =>
            {
                this.showOptions = this.dropdownToggled
            }, 10)
        },

        onOptionClicked (event, optionValue)
        {
            this.selectedValue = optionValue
        },

        setErrorMessage (message)
        {
            this.errorMessage = message
        },

        onDocumentClicked ()
        {
            if (this.$refs.options && DOMUtils.isMouseOverElement(this.$refs.options)) return

            if (!DOMUtils.isMouseOverElement(this.$el)) this.dropdownToggled = false
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.dropdown-select
{
    @content-padding: 2px 20px;
    @border-size: 1px;
    --height: 12vw;
    --font-size: 4vw;

    .OnTablet({
        --height: 6.5vw;
        --font-size: 2.2vw;
    });

    .OnDesktop({
        --height: 5vh;
        --font-size: 1.7vh;
    });

    height: var(--height);
    border: @border-size solid var(--theme-border-color);
    border-radius: 4px;
    cursor: pointer;
    font-size: var(--font-size);

    &.has-error
    {
        color: red;

        .selected
        {
            color: red;
        }
    }

    .selected
    {
        @text-color: var(--theme-text-color-light);

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: var(--theme-border-color);
        padding: @content-padding;
        height: inherit;
        color: @text-color;
        fill: @text-color;
        font-size: inherit;
        margin-top: -@border-size;
        padding-bottom: 2 * @border-size;

        &.has-value
        {
            .label
            {
                border-right: 1px solid var(--theme-border-color-extra-strong);
                padding-right: 20px;
                font-size: inherit;
            }

            .selected-value
            {
                display: inherit;
                font-size: inherit;
            }
        }

        .label
        {
            color: inherit;
        }

        .icon
        {
            fill: inherit;
            height: var(--font-size);
            vertical-align: middle;
            margin-left: 15px;
            transform: rotate(270deg);
            transition: transform 0.15s linear; 

            &.flipped
            {
                transform: rotate(90deg);
            }
        }

        .selected-value
        {
            display: none;
        }
    }

    .options
    {
        position: relative;
        background-color: var(--theme-content-background-color);
        border-radius: inherit;
        border-color: var(--theme-border-color-strong);
        z-index: 2;
        padding-left: @border-size;
        margin-left: -@border-size;
        padding-right: @border-size;
        margin-right: -@border-size;
        margin-top: 10px;
        margin-bottom: 10px;
        opacity: 0;
        transform: scale(1);
        transition: opacity 0.15s ease-out, transform 0.15s ease-out;
        font-size: inherit;
        box-shadow: var(--theme-box-shadow-sharp-diffuse);

        &.show
        {
            opacity: 1;
            transform: scale(1.05);
        }

        .option
        {
            display: flex;
            align-items: center;
            padding: @content-padding;
            height: var(--height);
            border-bottom: 1px solid var(--theme-border-color-light);
            font-size: inherit;
            margin-left: -@border-size;
            width: calc(100% - 38px);

            &:hover
            {
                background-color: var(--theme-border-color-light);
            }
        }
    }

    .hint
    {
        color: inherit;
        font-size: 2vh;
        padding-bottom: 20px;
        margin-top: 5px;
        margin-left: 5px;

        .OnLargeMobile({ font-size: 1.7vh; });
        .OnTablet({ font-size: 1.5vh; });
    }
}
</style>


// WEBPACK FOOTER //
// src/components/DropdownSelect.vue